import { RefObject } from "react";
import { calcShiftedAfterLine } from "../utils/utils";
import { Simuline } from "./Simuline";
import { DesktopState } from "./desktopState";


export function ActiveSheet({ desktopState, onCut, activeSheetRef }: { desktopState: DesktopState; onCut: (lineIdx: number) => void; activeSheetRef: RefObject<HTMLDivElement | null>; }) {
  let shifted = false;

  return <article className={`p-4 bg-[#F2E4DB] font-mono text-xs whitespace-pre w-[36rem] shadow overflow-x-hidden`} ref={activeSheetRef}>
    {desktopState.teletype.activePaper.map((line, index) => {
      let result = (
        <div
          key={index}
          onClick={() => onCut(index)}
          className={`border-b-1 min-h-4 border-dashed border-b-transparent ${desktopState.tool === "SCISSORS" ? "hover:border-b-red-500" : ""}`}
        ><Simuline text={line} shifted={shifted} /></div>
      );
      shifted = calcShiftedAfterLine(shifted, line);
      return result;
    })}
    <div><Simuline text={desktopState.teletype.line} shifted={shifted} cursor={true} /></div>
  </article>;
}
